module.exports = __webpack_public_path__ + "img/nouser.023d858a.svg";